import { Component, Input, OnInit } from '@angular/core';
import { Notice } from 'src/app/interfaces/main';
import { GeneralService } from 'src/app/services/general/general.service';

@Component({
  selector: 'app-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss']
})
export class NoticeComponent implements OnInit {

  @Input() notice: Notice | undefined;
  @Input() type: 'bar' | 'card' = 'bar';

  constructor(private generalService: GeneralService) { }

  ngOnInit(): void {
  }

  onClickNotice(): void {
    if (this.notice?.link) {
      this.generalService.openInappBrowser(this.notice.link);
    }
  }
}
